import axios from "axios";
import { createContext, useContext, useReducer } from "react"

const ReplyContext = createContext();

const serverUrl = 'https://osdevhub.com/homify_backend';

const initialState = {
    replies: [] ,
    replyIsLoading: false,
    replyErrorMessage: null
}

function reducer(state, action) {
    switch (action.type) {
        case 'loading':
            return{
                ...state,
                replyIsLoading: true
            }

        case 'addReply':
            return{
                ...state,
                replyIsLoading: false
            }
        case 'updateReply':
            return{
                ...state,
                replyIsLoading: false
            }

        case 'getReplies':
            return {
                ...state,
                replyIsLoading: false,
                replies: action.payload
            };

        case 'deleteReply':
            return {
                ...state,
                replyIsLoading: false,
            };
        case 'replyError':
            return{
                ...state,
                replyErrorMessage: action.payload
            }
    
        default:
            break;
    }
}

function ReplyProvider({children}) {
    const [{replies, replyIsLoading, replyErrorMessage }, dispatch] = useReducer(reducer, initialState)

    async function updateReply(id, data) {
        dispatch({ type: 'loading' });
        try {
            const response = await axios.patch(`${serverUrl}/api/replies/${id}`, data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
          if(response.data.message === "Reply updated successfully") {
            dispatch({
              type: 'updateReply',
            })
          }
        } catch (error) {
          dispatch({
            type: 'replyError',
            payload: error.response?.data?.message || error.message || 'Error updating reply'
        });

        console.error(error);
          
        }
  
      }

    async function addReply(replyData) {
        dispatch({ type: 'loading' });
    
        try {
            const response = await axios.post(`${serverUrl}/api/replies`, replyData);
    
            if (response.data.message === 'Reply added successfully') {
                dispatch({
                    type: 'addReply',
                });
            }
        } catch (error) {
            dispatch({
                type: 'replyError',
                payload: 'Error uploading reply'
            });
        }
    }

    async function getRepliesForProperty(id, user_id) {
        dispatch({
            type:'loading'
        })
        try {
        
            const response = await axios.get(`${serverUrl}/api/replies/${id}`);
            if (response.data.message === 'Replies retrieved successfully') {
                dispatch({
                    type: 'getReplies',
                    payload: response.data.data
                })
            }
            if(response.data.message === 'No replies found for this property'){
                dispatch({
                    type: 'getReplies',
                    payload: response.data.data
                })
            }
        } catch (error) {
            dispatch({
                type: 'replyError',
                payload: 'Error fetching data'
            })
        }
    }

    async function deleteReply(id) {
        dispatch({
            type:'loading'
        })
        try {
         
            const response = await axios.delete(`${serverUrl}/api/replies/${id}`);
            if (response.data.message === 'Reply deleted successfully') {
                dispatch({
                    type: 'deleteReply'
                })
            }
        } catch (error) {
            dispatch({
                type: 'replyError',
                payload: 'error'
            })
        }
    }


    return <ReplyContext.Provider value={{
        replies, 
        replyIsLoading, 
        replyErrorMessage,
        getRepliesForProperty,
        addReply,
        deleteReply,
        updateReply
        }}>
        {children}
    </ReplyContext.Provider>
}

function useReply() {
    const context = useContext(ReplyContext);
    if(context === undefined) throw new Error("You are using it outside the context");
    return context
}

export {ReplyProvider, useReply}